import React from 'react';
import {configureStore} from '@reduxjs/toolkit';
import userReducer from './user'

const store = configureStore(
  {
    reducer: {
      user: userReducer,
    },
  });

export default store;
